import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import useUser from 'src/hook/data/useUser';
import styles from './UpgradeButton.module.scss';

const UpgradeButton: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { userInfo, isProUser } = useUser();

    const handleClick = () => {
        navigate('/membership');
    };

    // Only render the button if the user is not a Pro member
    if (isProUser()) {
        return null;
    }

    return (
        <button
            className={styles.upgradeButton}
            onClick={handleClick}
        >
            {t('Upgrade')}
        </button>
    );
};

export default UpgradeButton;
